import {
  AgrEnvironment,
  AgrLoginTypes,
  IETFLocales,
  SignupSigninPolicy,
} from '@next/core-lib/environment';

export const environment: AgrEnvironment = {
  APPLICATION_NAME: 'MelkVermogen Scan',
  API_BASE_URL: 'http://localhost:4200',
  APIM_BASE_URL: 'http://localhost:4200/external',
  CLIENT_ID: '82c898ca-bc2d-4ce1-9ce0-c635fd17cbf0',
  REDIRECT_URL: 'http://localhost:4200',
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  APPLICATION_KEY: 'MelkVermogenScan',
  AUTHORIZED_BY: {
    MelkVermogenScan: ['Advisor', 'Administrator', 'GlobalAdministrator'],
  },
  APP_INSIGHTS_KEY: 'aaac3537-49ba-4259-8e8c-e7716f3902e9',
  DEFAULT_LOCALE: IETFLocales.nl,
  LOCALES: [IETFLocales.nl],
  PRODUCTION: true,
};
